import {
  FailureBadge,
  MetaLine,
  SpinningIcon,
  StyledFilter,
  StyledTitle,
  TitleLayout,
  TypeRow,
} from './styles';
import AlertIcon from '@/public/icons/alert.svg';
import { tagToColor } from '@/utils/function';
import React, { useMemo } from 'react';
import CommentAndOpinion from '@/components/Approval/RightContainer/ApprovalContent/TitleInfo/CommentAndOpinion';
import { ApprovalComment } from '@/types/api';

type P = {
  type: {
    name: string;
    tag: string;
    isLoading?: boolean;
  };
  subject: string;
  /** 제목 아래 회의 정보 라인 (미팅 이름 | 회의 일시) — 회의록 리스트 전용 */
  metaLine?: string;
  opinionCount?: number;
  commentCount?: number;
  lastOpinionBy?: {
    name: string;
    positionName: string;
    opinion: string;
    updatedAt: string;
  };
  latestComment?: ApprovalComment;
  isRead?: boolean;
  /** 문서 유형 옆 실패 라벨 — 예: 「업로드 실패」 (PORTAL-12583) */
  failLabels?: string[];
};

const TitleInfo = ({
  type,
  subject,
  metaLine,
  commentCount = 0,
  opinionCount = 0,
  lastOpinionBy,
  latestComment,
  isRead,
  failLabels = [],
}: P) => {
  const haveComments = useMemo(
    () =>
      opinionCount > 0 || commentCount > 0 || lastOpinionBy || latestComment,
    [opinionCount, commentCount, lastOpinionBy, latestComment],
  );

  return (
    <TitleLayout>
      <TypeRow>
        <StyledFilter colorSet={tagToColor(type.tag)}>
          {type.isLoading && <SpinningIcon />}
          {type.name}
        </StyledFilter>
        {failLabels.map((label) => (
          <FailureBadge key={label}>
            <AlertIcon width={16} height={16} />
            {label}
          </FailureBadge>
        ))}
      </TypeRow>
      <StyledTitle draggable={false} isRead={isRead}>
        {subject}
      </StyledTitle>
      {metaLine && <MetaLine>{metaLine}</MetaLine>}
      {haveComments && (
        <CommentAndOpinion
          commentCount={commentCount}
          opinionCount={opinionCount}
          lastOpinionBy={lastOpinionBy}
          latestComment={latestComment}
        />
      )}
    </TitleLayout>
  );
};
export default TitleInfo;
